import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  box: any;
  
  constructor() { }

  ngOnInit(): void {
  
  // const box = document.querySelector('.box')
  // const boxRect = this.box.getBoundingClientRect()

  // box?.addEventListener('mousemove', (e:any) =>{
  //   const xPos = (e.clientX - boxRect.left) / boxRect.width
  //   const xOffset = -(xPos - 0.5)
  //   const dxNorm =Math.min(Math.max(xOffset, -0.5),0.5)
  //   const yPos = (e.clientY - boxRect.top) / boxRect.height -0.5
  //   // box.style.transform = `perspective(1000px) rotateY(${ dxNorm * 45 }deg) rotateX(${yPos * 45}deg)`
  // })
  // box?.addEventListener('mouseleave',()=>{
  //   // box.getElementsByClassName('box').style.transform = 'none'
  // })

  }


}
